import React from 'react';
import { Disqus } from '@autovia-uk/polaris-components/components/atoms/Disqus';
import { Collapsible } from '@autovia-uk/polaris-components/components/molecules/Collapsible'; // has Heading, should be placed here
import { DisqusCount } from '@autovia-uk/polaris-components/components/molecules/DisqusCount';

export const getDisqusCollapsible = (siteUrl, url, title, nodeId, disqusShortname) => (
  <div className="polaris__comments" id="polaris_comments">
    <Collapsible
      title=""
      isOpen={false}
      iconOpen="polaris__ico-caret_down"
      iconClose="polaris__ico-caret_up"
      titleComponent={(
        <DisqusCount
          identifier={`node/${nodeId}`}
          url={`${siteUrl}${url}`}
          title={title}
          shortname={disqusShortname}
        />
      )}
      content={(
        <Disqus
          identifier={`node/${nodeId}`}
          url={`${siteUrl}${url}`}
          title={title}
          shortname={disqusShortname}
        />
      )}
    />
  </div>
);
